import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Row } from 'reactstrap';
import moment from 'moment';

//Context
import { useAuth } from '../../../context/auth';

// Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';
import mascaras from '../../../helpers/mascaras';

export default function RelatorioInscricaoMunicipaisGeradores({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();
    const refRelatorio = useRef();

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetasNaoRealizadas = [
        { value: "RAZÃO SOCIAL", objectValue: "razaoSocial", col: "6" },
        { value: "INSCRIÇÂO MUNICIPAL", objectValue: "inscricaoMunicipal", col: "6" }
    ];

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório inscrição municipais",
    });


    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} width={250} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de inscrição municipais</h4>
                    <Row>
                        <div className='col-4'>
                            {filtros.gerador_selected && <p><span className="fw-bold">Gerador:</span> {filtros.gerador_selected}</p>}
                        </div>
                        <div className='col-4'>
                            {filtros.cnpj && <p><span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(filtros.cnpj)}</p>}
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Lista de inscrições municipais</h5>
                    <Row>
                        <TabelaListagemFichas
                            headers={headersColetasNaoRealizadas}
                            items={dadosRelatorio}
                            scrollbar={false}
                        />
                    </Row>
                </div>
            </div>
        </MainCard>
    );
}
